// truncate.ts
import {Pipe} from "@angular/core";
import {ServiceConfig} from "../app/services-config";

@Pipe({
  name: 'addBaseUrl'
})
export class BaseUrlPipe {
  transform(value: string, args: string): string {
    return ServiceConfig.baseUrl + '/uploads/' + value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/baseurl.pipe.ts